import React from 'react';
import PropTypes from 'prop-types';

import { Button, Stack } from '@metarouter-private/mr-mui';

export default function DisableRevisionModalActions({ onCancel, onDisable, loading }) {
  return (
    <Stack direction="row" spacing={1}>
      <Button variant="outlined" onClick={onCancel} disabled={loading}>
        Cancel
      </Button>
      <Button variant="contained" onClick={onDisable} disabled={loading} data-test-id="disableRevisionButton">
        Disable Revision
      </Button>
    </Stack>
  );
}

DisableRevisionModalActions.propTypes = {
  onCancel: PropTypes.func.isRequired,
  onDisable: PropTypes.func.isRequired,
  loading: PropTypes.bool,
};
